import { render, staticRenderFns } from "./BookingDetail.vue?vue&type=template&id=0d6b9bc8&lang=pug&"
import script from "./BookingDetail.vue?vue&type=script&lang=ts&"
export * from "./BookingDetail.vue?vue&type=script&lang=ts&"
import style0 from "./BookingDetail.vue?vue&type=style&index=0&id=0d6b9bc8&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports